import React from 'react';
import {Redirect} from 'react-router';
import {NamedOAuth2Config} from 'security';

type InitSignInProps = {
    configs: NamedOAuth2Config[],
}

const findMatchingConfig = (url: URL, configs: NamedOAuth2Config[]): NamedOAuth2Config | null => {
    const appName = url.searchParams.get('app');
    if (appName) {
        return configs.find(value => value.name === appName) ?? null;
    }

    const oktaIssuer = url.searchParams.get('iss');
    if (oktaIssuer) {
        return configs.find(value => value.issuer.startsWith(oktaIssuer)) ?? null;
    }

    return null;
};

export const OktaInitSignIn = ({configs}: InitSignInProps) => {
    const matchingConfig = findMatchingConfig(new URL(window.location.toString()), configs);
    return (<Redirect to={`/${matchingConfig?.name ?? '404'}`}/>);
};
